export default __webpack_public_path__ + "static/media/pic2.38511a6c.jpg";